import { formatJsonDataset as fjd } from "../../components/renderers";

export const mainconfig = {

  orgunit: {
    service: {
      name: 'orgunit',
      title: 'Organizational Units',
      num: false,
      fields: [
        'rid','rfn','nam','shc','uti','utn','utc','uci','ucn','ucc','ugi','ugn','ugc',
        'oci','ocn','occ','upi','upn','upc','dsc','exi','sts','ast','stp'
      ],
      grid: [
        ['rfn','Reference'],
        ['nam','Name'],
        ['shc','Code'],
        ['utn','Type'],
        ['ucn','Category'],
        ['ugn','Group'],
        ['ocn','Class'],
        ['upn','Parent'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Reference', v:'rfn' },
          { t:'Code', v:'shc' }
        ],
        def:'nam'
      },
      eform: [
        { id:'rix', label:'Record ID', type:'ai', req:0, ops:{},off:['add','edit','view'] },
        { id:'rfn', label:'Reference', type:'tf', req:1, ops:{},off:['add','edit','view'] },
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'uti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unittype' } },
        { id:'uci', label:'Category', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitcat' } },
        { id:'ugi', label:'Group', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitgroup' } },
        { id:'oci', label:'Class', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitclass' } },
        { id:'upi', label:'Parent', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'orgunit' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  staff: {
    service:{
      name:'staff',
      title:'Staff',
      num: false,
      fields:[
        'rid','rfn','sid','nam','uni','unn','unc','sti','stn','stc','sli','sln','slc','sri','srn','src',
        'usi','usn','usm','eml','mbn','rmk','exi','sts','ast','stp'
      ],
      grid:[
        //['rfn','Reference'],
        ['sid','Staff ID'],
        ['nam','Name'],
        ['unn','Unit'],
        ['stn','Type'],
        ['sln','Level'],
        ['srn','Role'],
        ['usn','Username'],
        ['eml','Email'],
        ['mbn','Mobile'],
        //['rmk','Remarks'],
        //['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu:[
          { t:'Name', v:'nam' },
          { t:'Email', v:'eml' },
          { t:'Mobile', v:'mbn' }
        ],
        def:'nam'
      },
      eform:[
        { id:'rix', label:'Record ID', type:'rf', req:0, ops:{} },
        { id:'rfn', label:'Reference', type:'tf', req:1, ops:{} },
        { id:'sid', label:'Staff ID', type:'tf', req:1, ops:{} },
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'uni', label:'Unit', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'orgunit' } },
        { id:'sti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'stafftype' } },
        { id:'sli', label:'Level', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'stafflevel' } },
        { id:'sri', label:'Role', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'staffrole' } },
        { id:'usi', label:'User', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'user' } },
        { id:'eml', label:'Email', type:'tf', req:0, ops:{} },
        { id:'mbn', label:'Mobile', type:'tf', req:0, ops:{} },
        { id:'rmk', label:'Remarks', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create:true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  product: {
    service: {
      name: 'product',
      title: 'Products',
      num: true,
      fields: ['rid','nam','shc','pci','pcn','pcc','umi','umn','umc','dsc','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['pcn','Category'],
        ['umn','UOM'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Category', v:'pcn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'pci', label:'Category', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productcategory' } },
        { id:'umi', label:'UOM', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'uom' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: {}
  },

  staffplan: {
    service: {
      name: 'staffplan',
      title: 'Staff Plans',
      num: true,
      fields: ['rid','cci','ccn','ccc','bpi','bpn','bpc','sri','srn','src','sli','sln','slc','qtp','qta','amp','ama','dsc','edi','edn','edc','dcd','exi','sts','ast','stp'],
      grid: [
        ['ccn','Cost Center'],
        ['bpn','Period'],
        ['srn','Role'],
        ['sln','Level'],
        ['qtp','Planned Qty'],
        ['qta','Actual Qty'],
        ['amp','Planned Amount'],
        ['ama','Actual Amount'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Cost Center', v:'ccn' },
          { t:'Period', v:'bpn' },
          { t:'Role', v:'srn' }
        ],
        def:'ccn'
      },
      eform: [
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'sri', label:'Role', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'staffrole' } },
        { id:'sli', label:'Level', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'stafflevel' } },
        { id:'qtp', label:'Planned Qty', type:'nf', req:0, ops:{} },
        { id:'qta', label:'Actual Qty', type:'nf', req:0, ops:{} },
        { id:'amp', label:'Planned Amount', type:'nf', req:0, ops:{} },
        { id:'ama', label:'Actual Amount', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

};